import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/batch-import-hotel-order',
      name: 'admin-batch-import-hotel-order',
      component: () => import(/* webpackChunkName: "page-admin-hotel-offlin-order-batch-import-hotel-order" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "量导入酒店批线下订单"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "酒店线下订单管理"
                                        },
                                        {
                                                  name: "量导入酒店批线下订单"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
